export default __webpack_public_path__ + "static/media/img_other10.bff1a50a.webp";